import TableHeader from "@ihs-widget/components/StatsConsole/Widgets/H2HWidget/parts/Table/TableHeader";
import TableLegend from "@ihs-widget/components/StatsConsole/Widgets/H2HWidget/parts/Table/TableLegend";
import TableRow from "@ihs-widget/components/StatsConsole/Widgets/H2HWidget/parts/Table/TableRow";
import { useEffect } from "react";

interface TableProps {
    tableData: any;
    isLegendEnebled?: boolean;
    colorLegend?: Array<{
        color: string;
        label: string;
        description: string;
    }>;
    marginTop?: string;
    marginBottom?: string;
}

const Table = ({ tableData, colorLegend, isLegendEnebled = true, marginTop = '22px', marginBottom = '0px' }: TableProps) => {

    return (
        <div data-testid="h2h-table-container" className='flex justify-center items-center flex-col w-full'
        style={{ marginTop: marginTop, marginBottom: marginBottom }}>
            <TableHeader />


            {tableData?.tableRows
                ?.sort((a: any, b: any) => a.no - b.no)
                ?.map((row: any, index: number) => (
                    <TableRow
                        key={index}
                        no={row.no}
                        leagueName={row.leagueName}
                        teamName={row.teamName}
                        playedMatches={row.playedMatches}
                        plusMinus={row.plusMinus}
                        points={row.points}
                        from={row.from}
                        isHighlighted={row?.inPlay}
                        qualification={row?.qualification}
                        qualificationRaw={row?.qualificationRaw}
                        color={row?.color}
                    />
                ))}
            {colorLegend && isLegendEnebled && (
                <div data-testid="h2h-table-legend" className='flex justify-center items-center mt-[24px] mb-[5px] w-full max-w-full'>
                    <TableLegend colorLegend={colorLegend}/>
                </div>
            )}
        </div>
    )
}

export default Table;